import React from 'react';

function DownloadResourceIcon() {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32"
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    transform: "rotate(90 15 16)"
  }, React.createElement("circle", {
    cx: "15",
    cy: "15",
    r: "15"
  }), React.createElement("circle", {
    cx: "15",
    cy: "15",
    r: "14.375",
    stroke: "#CBCBCB",
    strokeWidth: "1.25"
  })), React.createElement("path", {
    stroke: "#CBCBCB",
    strokeWidth: "1.25",
    d: "M11.59 15.174l4.183 4.16 4.183-4.16m-4.184 3.841V6.785"
  }), React.createElement("path", {
    stroke: "#CBCBCB",
    d: "M11.59 22.406h8.366"
  })));
}

export default DownloadResourceIcon;